<template>
  <div class="collection-single">
    <!--<div class="container is-boxed-fluid">-->
      <!--<div class="page-headline">-->
        <!--<ul class="breadcrumbs">-->
          <!--<li>-->
            <!--<router-link :to="{name: 'home'}">Homepage</router-link>-->
          <!--</li>-->
          <!--<li>-->
            <!--<router-link :to="{name: 'shop'}">Collections</router-link>-->
          <!--</li>-->
          <!--<li>-->
            <!--<router-link-->
              <!--:to="{name: 'shop'}"-->
            <!--&gt;Petoor SS 1920 հավածածուն և Art deco- նորաձևության շարժումը</router-link>-->
          <!--</li>-->
        <!--</ul>-->
      <!--</div>-->
    <!--</div>-->
    <h1>{{$t($route.params.page).title}}</h1>
    <div>
      <div
        class="connected-rows"
        v-for="(section, key) in $t($route.params.page).sections"
        :key="key"
      >
        <div class="container is-boxed-fluid ns">
          <div class="row ns first-row">
            <div class="col-6 col-md-12 left-col">
              <img :src="section.image_1" alt />
            </div>
            <div class="col-6 col-md-12 right-col">
              <div class="right-item">
                <h2 class="section-title" :class="{'has-author': section.author}">{{section.title}}</h2>
                <p class="author" v-if="section.author">{{section.author}}</p>
                <p class="description" v-if="section.description">{{section.description}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row ns last-row">
            <div class="col-6 col-md-12 left-col">
              <p>{{section.short_description}}</p>
            </div>
            <div class="col-6 col-md-12 right-col ns">
              <div>
                <img :src="section.image_2" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'collection',
  i18n: {
    messages: {
      en: {
        'petoor-ss-1920': {},
        'fall-winter-19-20': {},
        'petoor-silver-minimalistic-collection': {
          title: 'PETOOR SILVER-MINIMALISTIC COLLECTION',
          sections: [
            {
              title:
                "““Minimalism is not a style, it is an attitude, a way of being. It's a fundamental reaction against noise, visual noise, disorder, vulgarity’’.",
              author: 'Massimo Vignelli',
              description: '',
              image_1:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-1.jpg',
              image_2:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-2.jpg',
              short_description:
                "Silhouette, layering..in each piece of jewellery, it's possible to find one’s unique perception of aesthetics. Finding the unique piece of jewellery best suited for one’s unique facial structure is simple as our geometric shapes conform effortlessly to the unique shape of any face."
            },
            {
              title:
                '“If I already have a vision, my work is almost done. The rest is a technical problem.”',
              author: 'Hiroshi Sugimoto',
              description:
                'Geometric formulas are the main source of inspiration for Petoor’s new silver line. You can find jewellery designs with multilayered triangles and oval shapes while maintaining our signature Art deco style. Our oval jewellery all have a starting point and directions. Being one of today’s common fashion trends, Petoor has made it the centrepiece of its collection.',
              image_1:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-3.jpg',
              image_2:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-4.jpg',
              short_description:
                "Silhouette, layering..in each piece of jewellery, it's possible to find one’s unique perception of aesthetics. Finding the unique piece of jewellery best suited for one’s unique facial structure is simple as our geometric shapes conform effortlessly to the unique shape of any face."
            },
            {
              title:
                'Each set of jewellery contains a ring, an earring, and a necklace that can be worn together or separately.',
              description:
                'Petoor Silver is the ideal gift for loved ones, friends or just for your own personal pleasure.',
              image_1:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-5.jpg',
              image_2:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-6.jpg',
              short_description:
                'Our most popular piece of Petoor silver is a trendy ear cuff for a single ear. It conforms perfectly with the shape of the ear and goes beautifully with a small companion earring for the other ear. These Petoor bestsellers are both feminine and cute.'
            },
            {
              title: 'Petoor uses only 925 silver in its jewellery',
              description:
                'Which is a high-quality metal that never loses its external shine making it perfect for sensitive and delicate skin.',
              image_1:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-7.jpg',
              image_2:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-8.jpg',
              short_description: ''
            }
          ]
        }
      },
      hy: {
        'petoor-ss-1920': {
          title: 'Petoor SS 1920 հավածածուն և Art deco- նորաձևության շարժումը',
          sections: [
            {
              title: 'Art deco-ն Petoor-ի 1920 SS հավաքածուում',
              description:
                'Petoor-ի գարուն-ամառ 2019 հավաքածուն ոգեշնչված է 1920- ականների էսթետիկայից, art deco ոճով: Այն իրենից ներկայացնում է 1920 ականաների կանանց կերպարի ժամանակակից մարմնավորում։ Հավաքածուն իր մեջ ներառում է հագուստի դիզայնի, 1920 ականների ոճով դետալների, զարդերի և իհարկե ճարտարապետական ոճի յուրահատկությունները։ Դրանք են՝ Petoor-ային պիժամաներ և 1920 ականների բոլոր կանոներով կոկիկ հագնված տղամարդու կոստյում-եռյակները, որոնք տեղափոխվել են կնոջ զգեստապահարան։',
              image_1: '/img/collections/Petoor_SS_1920/Petoor_SS_1920-1.jpg',
              image_2: '/img/collections/Petoor_SS_1920/Petoor_SS_1920-2.jpg',
              short_description:
                'Մեր հավաքածուին բնորոշ են նաև 1920 ականներին նորաձև ծոպերը և ուսերից ուղիղ իջնող զգեստները։ Կերպարներն ամբողջացնում էին ծոպերով դրվագրված գլխազարդերը՝ գլխակապերի և թասակն-կեղծամների տեսքով։'
            },
            {
              title: 'Petoor 1920 ss հավաքածուի Ցուցադրությունը',
              description:
                '2019 թ․-ի Մարտի 10-ին Dvin Hall-ում տեղի ունեցավ Petoor գարուն-ամառ 1920 (2019) հավաքածուի Ցուցադրությունը: Petoor 1920 ss հավաքածուն ցուցադրվել է Dvin Hall-ում։ Ընտրությունը պատահական չէր։ Ներքին հարդարման art deco ոճավորումը ավելի քան կրկնում ու բնութագրում էր ողջ հավաքածուն:',
              image_1: '/img/collections/Petoor_SS_1920/Petoor_SS_1920-3.jpg',
              image_2: '/img/collections/Petoor_SS_1920/Petoor_SS_1920-4.jpg',
              short_description:
                '2019 թ․-ի Մարտի 10-ին Dvin Hall-ում տեղի ունեցավ Petoor գարուն-ամառ 1920 (2019) հավաքածուի Ցուցադրությունը: Petoor 1920 ss հավաքածուն ցուցադրվել է Dvin Hall-ում։ Ընտրությունը պատահական չէր։ Ներքին հարդարման art deco ոճավորումը ավելի քան կրկնում ու բնութագրում էր ողջ հավաքածուն:'
            },
            {
              title: '',
              description:
                'Երեկոն բացի հավաքածուի ցուցադրությունից իր ծրագրում ներառել էր նաև IQOS նորարարական տոխնոլոգիաների մասին կարճ անդրադարձը, իսկհամաշխարհային Porsche ապրանքանիշի հայաստանյան գրասենյակը ներկայացրեց վերջին Posche Macan-ը:',
              image_1: '/img/collections/Petoor_SS_1920/Petoor_SS_1920-5.jpg',
              image_2: '/img/collections/Petoor_SS_1920/Petoor_SS_1920-6.jpg',
              short_description:
                'Մոդելների դիմա և վարսահարդարումն ապահովել էր Aga Image Studio-ն: Հրավիրված մոտ 300 հյուրերի թվում էին շոու-բիզնեսի ներկայացուցիչներ, դիզայներներ, դեսպանատների և բանկերի ներկայացուցիչներ, ապրանքանիշի հավատարիմ հաճախորդները և այլն:'
            }
          ]
        },
        'fall-winter-19-20': {
          title: 'Fall Winter 19/20',
          sections: [
            {
              title: 'FallWinter 2019-20',
              author: 'Քաղաքային շիկը 70-ականներից',
              description:
                'Petoor-ի նոր աշուն-ձմեռ 2019-20 հավաքածուն առաջարկում է 70-ականների էսթետիկան՝ որպես զգացողություն և աշնանային գունային գամման՝ որպես պատկերընկալում:',
              image_1: '/img/collections/Fall_Winter/Fall_Winter 1920-1.jpg',
              image_2: '/img/collections/Fall_Winter/Fall_Winter 1920-2.jpg',
              short_description:
                'Կաշին, անջրանցիկ, խշխշան գործվածքները, ջրի պես հոսուն մետաքսը, ամենուր հանդիպող դարսերը՝ համադրված ազատ, խալաթային ուրվագծերի հետ. ահա այն բաղադրիչները, որոնցից կազմված է Petoor-ի նոր աշուն-ձմեռ 2019-20 հավաքածուն:'
            },
            {
              title: '',
              description:
                'Վերանայեք դենդիների, գաղտնի գործակալների ու տարբեր այլ արկածների մասին պատմող ֆիլմերը 70-ականներից, փորձեք փակել աչքերն ու մտովի հետ գնալ կես դար, երբ կյանքում ամեն մանրուք նշանակություն ուներ, ամեն ինչ այնքան արագ չէր, որքան այժմ, երբ տղամարդիկ գիտերին, թե ինչպես է պետք վարվել իսկական լեդիի հետ, իսկ կանայք հաճույք էին ստանում թույլ և անպաշտպան լինելուց:',
              image_1: '/img/collections/Fall_Winter/Fall_Winter 1920-3.jpg',
              image_2: '/img/collections/Fall_Winter/Fall_Winter 1920-4.jpg',
              short_description:
                'Մեծ մետաքսյա բանտերով զարդարված զգեստներն ու վերնաշապիկները ճիշտ հակադրության մեջ են կաշվե զգեստների հետ: Գոտկատեղում ձգվող երիզով հավաքված կաշվե ժակետները կրեք լայն դարսածալով շագանակագույն կապրի տաբատով, իսկ ծաղկանախշ աշնանային վերարկուն կգունավորի օրը:'
            },
            {
              title: '',
              description:
                'Նոր հավաքածուն կազմված է մեծամասամբ կրելի, casual հագուստի մասերից, առկա են Petoor-ի խալաթային զգեստներն ու պիժամա-ժակետները, հարմարավետ ամենօրյա տաբատներ և թեթև աշնանային վերարկուներ:',
              image_1: '/img/collections/Fall_Winter/Fall_Winter 1920-5.jpg',
              image_2: '/img/collections/Fall_Winter/Fall_Winter 1920-6.jpg',
              short_description:
                'Petoor նոր աշուն-ձմեռ 2019-20 հավաքածուն արդեն ներկայացված է 5Concept խանութ-սրահում Սայաթ-Նովա 5 հասցեում:'
            }
          ]
        },
        'petoor-silver-minimalistic-collection': {
          title: 'PETOOR SILVER-MINIMALISTIC COLLECTION',
          sections: [
            {
              title:
                '«Մինիմալիզմը ոճ չէ։ Դա կյանքի հանդեպ ունեցած վերաբերմունք է։ Այն  հակազդումն է ընդդեմ տեսողական և լսողական աղմուկի, խառնաշփոթի և գռեհկության»։',
              author: 'Մասիմո Վիգելի',
              description: '',
              image_1:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-1.jpg',
              image_2:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-2.jpg',
              short_description:
                'Մինիմալիստական շարժումը իր ատացոլումն է գտել մարդկային գործունեության բոլոր ասպարեզներում։ Այն ներառում է դիզայնը, տան ինտերիերի հարդարանքը,  ճարտարապետությունը, արվեստն ու գրականություն, հոգեբանությունը և այլն։ Մինիմալիզմը ոչ միայն ոճ և ստեղծագործական ուղղություն է այլևմտածողություն և մտածելակերպ։'
            },
            {
              title:
                '«Եթե դու արդեն ունես տեսլական, նշանակում է որ գործը գրեթե արված է։ Մնացածը տեխնիկական խնդիր է»։',
              author: 'Հիրոշի Սումիմոտո',
              description:
                'Նոր շարքը ոգեշնչված է երկրաչափական ֆորմաներից, եռանկյունն ու շրջանը իրենց տիեզերական զարգացումներն են ապրում նոր հավաքածուի մեջ՝ դառնալով բազմաշերտ, բայց մինիմալիստական համադրություն մի կողմից, և ելման կետ կամ ուղղություն ունեցող շեղված շրջան՝ մյուս կողմից:',
              image_1:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-3.jpg',
              image_2:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-4.jpg',
              short_description:
                'Մինիմալիզմը՝ որպես այժմ նորաձևության և դիզայնի մեջ ընդհանրապես ամենատարածված միտում, դարձել է հավաքածուի առանցքը: Ուրվագիծ, ֆակտուրա, շերտավորումներ... Զարդերից յուրաքանչյուրում կարող եք գտնել էսթետիկայի ձեր ընկալումը, երկրաչափական ամեն ձև համապատասխանում է դիմագծի, դեմքի օվալի որևէ տեսակի, մնում է միայն գտնել ձերը:'
            },
            {
              title:
                'Each set of jewellery contains a ring, an earring, and a necklace that can be worn together or separately.',
              description:
                'Շարքի երկրաչափական էտյուդներից յուրաքանչյուրը ներկայացված է ամբողջական հավաքածուի տեսքով՝ մատանի, վզնոց կախազարդով, ականջօղեր, և այս բաղկացուցիչները կարելի է կրել և ձեռք բերել ինչպես միասին, այնպես էլ միմյանցից զատ, ևս մեկ անգամ նշենք, որ զարդերը կարող են դառնալ լավագույն նվերը ձեր մտերիմների, ընկերների և հենց ձեզ համար:',
              image_1:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-5.jpg',
              image_2:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-6.jpg',
              short_description:
                'Օրինակ` դրանք կլոր, եռանկյունի, և այլ ֆորմաների տեսքով պատրաստված զարդեր են, որոնցից յուրաքանչյուրի ֆորմայով կարող եք գտնել հավաքածու․ մատանի, վզնոց կախազարդով, ականջօղեր։ \n' +
                '\n' +
                'Զարդերը կարող եք կրել ինչպես միասին, այնպես էլ առանձին։ Դրանք  բազմաշերտ են և մինիմալիստական ոճով։\nՀատկապես շեշտենք տարբերվող և տրենդային ականջօղերը, որոնք մի կողմի համար ամբողջությամբ ականջի ձևով են, իսկ մյուս կողմի ականջին կարող եք կրել նույն ֆորմայով բայց ականջօղի ավելի փոքր տարբերակը, որը շատ նուրբ է կանացի։'
            },
            {
              title: 'Petoor uses only 925 silver in its jewellery',
              description:
                'Նշենք նաև, որ արծաթյա զարդերը 925 հարգի են, ինչը նշանակում է, որ այն որակապես բարձր մետաղից է, արտաքին փայլը չի կորցնում, ինչպես նաև զգայուն և նուրբ մաշկին է հարմար։',
              image_1:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-7.jpg',
              image_2:
                '/img/collections/Silver_Minimalistic_Collection/PETOOR_SILVER-MINIMALISTIC_COLLECTION-8.jpg',
              short_description: ''
            }
          ]
        }
      }
    }
  },
  data () {
    return {
      page: {}
    }
  }
}
</script>

<style lang="scss">
.collection-single {
  padding-top: 130px;

  @include mq($ms){
    padding-top: 90px;
  }

  h1 {
    font-size: 46px;
    font-family: $font-bold;
    margin: 0 auto 60px auto;
    text-align: center;
    max-width: 800px;

    @include mq($ms){
      font-size: 24px;
      padding: 0 15px;
      margin-bottom: 30px;
    }
  }

  .connected-rows {
    .section-title {
      font-size: 26px;
      line-height: 36px;
      &.has-author {
        margin-bottom: 15px;
      }

      @include mq($ms){
        font-size: 18px;
        margin-bottom: 0;
        line-height: normal;
      }
    }
    @include mq($ms){
      .right-item{
        padding-bottom: 0!important;
      }
    }
    p {
      &.author {
        position: relative;
        margin-top: 0;
        padding-top: 15px;
        font-family: $font-bold;
        &:before {
          position: absolute;
          top: 0;
          border-top: 1px solid $main-color;
          content: "";
          display: block;
          width: 60px;
        }
      }
    }
  }
}
</style>
